import { PriceGroup } from "shared/types/__generated__/graphql"

export const NO_PRICE_GROUP_NAME = "_NONE_"

export function formatPriceGroupName(group: PriceGroup, noGroupName: string) {
  return group.name === NO_PRICE_GROUP_NAME ? noGroupName : group.name
}
